// extracted by mini-css-extract-plugin
export default {"root":"Loading_root__16hzI","spinner":"Loading_spinner__4DYC8","rotateSpinner":"Loading_rotateSpinner__6J4cu","full-screen":"Loading_full-screen__OJxJI"};